import CardHistory from './CardHistory';
export default CardHistory;
